var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditButtonGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1481 6.852C15.2427 6.75897 15.3702 6.70717 15.5029 6.70792C15.6355 6.70867 15.7625 6.76191 15.8561 6.856L18.1441 9.144C18.1909 9.19018 18.2281 9.24514 18.2537 9.30575C18.2792 9.36635 18.2926 9.4314 18.293 9.49717C18.2933 9.56293 18.2807 9.62813 18.2559 9.68902C18.231 9.7499 18.1944 9.80529 18.1481 9.852L11.0001 17L8.00006 14L15.1481 6.852ZM7.00006 15L10.0001 18L6.49006 18.877C6.22006 18.945 6.05406 18.785 6.12306 18.51L7.00006 15Z",
    fill: "#75848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButtonGray);
export default __webpack_public_path__ + "static/media/editButtonGray.0b7362986caa132bb7437f216593cbab.svg";
export { ForwardRef as ReactComponent };